import { Inbox, type LucideIcon } from 'lucide-react';
import { Button } from './ui/Button.js';

export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
}: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-20 text-center">
      <div
        className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl"
        style={{ background: 'var(--color-accent-soft)', color: 'var(--color-accent)' }}
      >
        <Icon className="h-6 w-6" />
      </div>
      <p className="text-sm font-medium text-[var(--color-ink)]">{title}</p>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-[var(--color-ink-faint)]">{description}</p>
      )}
      {action && (
        <Button className="mt-4" size="sm" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}

export function ListSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <div className="space-y-1 px-1 py-1">
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className="h-8 animate-pulse rounded-md"
          style={{ background: 'var(--color-surface-3)', width: `${88 - i * 6}%` }}
        />
      ))}
    </div>
  );
}
